export function googleAnalytics (url) {
   gtag ('config' , 'UA-114829564-1' , { 'page_path' : url});
}



//////////////////
// WEBPACK FOOTER
// ./src/assets/script.js
// module id = ./src/assets/script.js
// module chunks = main